import { ENVIRONMENTS, getEnvFromHostname } from 'pages/utils/getEnvFromHostname';

const PROPOSAL_PREVIEW_PATH = '/p/proposals/preview';

// map each LSR environment to its corresponding invoicing URL
const envToBaseUrl: Record<ENVIRONMENTS, string> = {
  [ENVIRONMENTS.LOCALHOST]: 'https://local.qmach.in',
  [ENVIRONMENTS.DEVELOPMENT]: 'https://local.qmach.in',
  [ENVIRONMENTS.STAGING]: 'https://invoicing-web-cpq.lightspeedstg.app',
  [ENVIRONMENTS.PRODUCTION]: 'https://invoicing.lightspeed.app',
};

// build full proposal preview URL based on current environment
export const getProposalPreviewURL = (): string => {
  const base = envToBaseUrl[getEnvFromHostname()];
  return `${base}${PROPOSAL_PREVIEW_PATH}`;
};
